var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlayVideoFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40.0 40.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223,0 C228.522847,1.37012913e-14 233,4.4771525 233,10 L233,154.655172 C233,160.17802 228.522847,164.655172 223,164.655172 L10,164.655172 C4.4771525,164.655172 6.76353751e-16,160.17802 0,154.655172 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 L223,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.0286719,0 40,8.9721875 40,20 C40,31.0278125 31.0286719,40 20,40 C8.97132812,40 0,31.0278125 0,20 C0,8.9721875 8.97132812,0 20,0 Z M16.2842188,11.7992969 C16.0286719,11.6324219 15.6982812,11.6235156 15.4346094,11.7683594 C15.1660156,11.9148437 15,12.1948437 15,12.5 L15,27.5 C15,27.8051563 15.1660156,28.0851563 15.4346094,28.2316406 C15.5582813,28.2991406 15.6966406,28.3333594 15.8333594,28.3333594 C15.9896094,28.3333594 16.1475,28.289375 16.2842188,28.2007031 L27.9508594,20.7007031 C28.1885156,20.5476562 28.3333594,20.2832031 28.3333594,20 C28.3333594,19.7167969 28.1885156,19.4522656 27.9508594,19.2992969 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.0 -455.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 393.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.0 1.8474111129762605e-13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.0 62.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 40,0 40,40 0,40 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.8)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayVideoFile);
export default __webpack_public_path__ + "static/media/icPlayVideoFile.ef664a85dd4f7398727376e6154cb6f9.svg";
export { ForwardRef as ReactComponent };